export default function getResponseMessage(response) {
  if (response?.config?.method !== 'get') {
    if (response?.data?.message) {
      const { message, status } = response.data;
      return message || status;
    }
  }
  return null;
}
